<template>
    <div class="change_pin">
        <TitleCommon title="Change PIN" :isShowButtonBack="true" />
        <div class="change_pin__container">
            <div class="change_pin__box">
                <div class="change_pin__form">
                    <template v-for="(item, index) in formItem" :key="index">
                        <InputCommon :inputItem="item" @on-change-input-common="changeValueLogin" :value="dataForm[item.name]" />
                    </template>
                    <div class="form-action">
                        <ButtonCommon
                            :isNoHover="true"
                            :isLoading="isLoading"
                            :isLoadingWhiteColor="true"
                            type="active"
                            value="Change PIN"
                            @on-click-button-common="handleSubmit"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import EventBus from '@/utils/EventBus';
import languageMixins from '@/mixins/language-mixins';
import authService from '@/services/auth.service';
import ButtonCommon from '@/components/common/button/button.vue';
import InputCommon from '@/components/common/input/input.vue';
import TitleCommon from '@/components/common/title/index.vue';

import { isArrayEmpty, isStrEmpty, parseProxyObject } from '@/utils/utils';

export default {
    mixins: [languageMixins],
    components: { ButtonCommon, InputCommon, TitleCommon },
    data() {
        return {
            isLoading: false,
            dataForm: {
                oldPin: '',
                newPin: '',
                confirmPin: '',
            },
            formItem: [
                {
                    label: 'old pin',
                    name: 'oldPin',
                    type: 'password',
                    required: true,
                },
                {
                    label: 'new pin',
                    name: 'newPin',
                    type: 'password',
                    required: true,
                },
                {
                    label: 'new pin retype',
                    name: 'confirmPin',
                    type: 'password',
                    required: true,
                },
            ],
        };
    },
    methods: {
        changeValueLogin(payload) {
            let { event, name } = payload;
            this.dataForm[name] = event.target.value;
        },

        async handleSubmit() {
            try {
                this.isLoading = true;

                const dataForm = parseProxyObject(this.dataForm);

                if (isStrEmpty(dataForm.oldPin) || isStrEmpty(dataForm.newPin) || isStrEmpty(dataForm.confirmPin)) {
                    const param = {
                        text: 'please input old pin and new pin!',
                        type: 'warning',
                        isTranslate: true,
                    };
                    EventBus.emit('show-notications', param);
                    this.isLoading = false;
                    return false;
                }

                if (dataForm.newPin !== dataForm.confirmPin) {
                    const param = {
                        text: 'New pin and confirm pin do not match!',
                        type: 'warning',
                        isTranslate: true,
                    };
                    EventBus.emit('show-notications', param);
                    this.isLoading = false;
                    return false;
                }

                const res = await authService.changePin(dataForm.oldPin, dataForm.newPin, dataForm.confirmPin);
                if (res.code !== '200' && res.code !== 200) {
                    let message = '';
                    !isArrayEmpty(res.errors)
                        ? res.errors.forEach((element) => {
                              message += element.message;
                          })
                        : (message = res.message);

                    const param = {
                        text: message,
                        type: 'error',
                    };
                    EventBus.emit('show-notications', param);
                } else {
                    this.dataForm.oldPin = '';
                    this.dataForm.newPin = '';
                    this.dataForm.confirmPin = '';

                    const param = {
                        text: 'SUCCESS',
                        type: 'success',
                    };
                    EventBus.emit('show-notications', param);
                }
                this.isLoading = false;
            } catch (e) {
                this.isLoading = false;
                console.log(e, 'err');
            }
        },
    },
};
</script>
<style lang="scss">
@import '@/public/scss/change-pin/index.scss';
</style>
